import {default as cx} from "classnames"

export function Question({questionText, isRequired = true}) {
    return (
        <div className="ribbon ribbon-top ribbon-vertical">
            <h1 className={cx("fw-bolder fs-3 my-0", {"required-hc": isRequired})}>{questionText}</h1>
        </div>
    )
}
